<template>
  <Modal v-model="visible" title="新增开票" :footer-hide="true" :mask-closable="false" class="my-modal top" width="800px">
    <Form ref="formValidate" :label-width="100" :model="formData" class="page-form less">
      <FormItem label="发票类型" prop="billType">
        <Select v-model="formData.billType" clearable>
          <Option value="1">普票</Option>
          <Option value="2">专票</Option>
        </Select>
      </FormItem>
      <FormItem label="发票代码" prop="billCode">
        <Input v-model="formData.billCode" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="发票号" prop="billNum" :rules="$units.formRule.required('请输入发票号')">
        <Input v-model="formData.billNum" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="发票金额" prop="billAmount" class="form-item" :rules="$units.formRule.required('请输入发票金额', 'change', 'number')">
        <InputNumber v-model="formData.billAmount" :min="0" placeholder="请输入"></InputNumber>
      </FormItem>
      <FormItem label="开票人" prop="billDrawer">
        <Input v-model="formData.billDrawer" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="开票日期" prop="billDate" :rules="$units.formRule.objRequired('请选择开票日期')">
        <DatePicker transfer v-model="formData.billDate" format="yyyy-MM-dd" type="date" placeholder="请选择"> </DatePicker>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input v-model="formData.remark" type="textarea" :rows="4" placeholder="请输入" clearable />
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import filter from '@/api/filter';

export default {
  components: { uploadNew },
  data() {
    return {
      filter,
      visible: false,
      imgUrl: '',
      formData: {
        billAmount: null
      }
    };
  },
  methods: {
    open(item) {
      this.formData = JSON.parse(JSON.stringify(item));
      this.formData.remark = '';
      this.formData.billAmount = null;
      this.visible = true;
    },

    submit() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.$http({
            url: '/buz/settlementReport/addCheckBill',
            type: 'POST',
            data: {
              reportId: this.formData.id,
              billType: this.formData.billType,
              billCode: this.formData.billCode,
              billNum: this.formData.billNum,
              billAmount: this.formData.billAmount,
              billDrawer: this.formData.billDrawer,
              billDate: filter.filterTime(this.formData.billDate, 'YYYY-MM-DD'),
              remark: this.formData.remark
            }
          }).then(() => {
            this.$notice.success('操作成功');
            this.$emit('success');
            this.visible = false;
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-date-picker {
  width: 100%;
}

/deep/ .ivu-modal-body {
  padding-top: 20px !important;
}

/deep/ .ivu-form {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

/deep/ .ivu-form-item {
  width: 50%;
}
</style>
